export const statusOptions = [
  { value: 'draft', label: 'draft' },
  { value: 'published', label: 'published' },
  { value: 'unpublished', label: 'unpublished' },
];

export const createStatusOptions = [
  { value: 'draft', label: 'draft' },
  { value: 'published', label: 'published' },
];

//NOTE: For version1 we should consider only digital subscription product category
export const productCategoryOptions = [
  {
    value: 'digital_subscription',
    label: 'Digital subscription product',
  },
  {
    value: 'physical_subscription',
    label: 'Physical subscription product',
  },
];

// TODO: Later this will be replaced by the tenant tax options from the backend
export const tenantTaxOptions = [
  {
    value: 0,
    label: `${0} %`,
  },
  {
    value: 12,
    label: `${12} %`,
  },
  {
    value: 25,
    label: `${25} %`,
  },
];

export const billingPeriods = [
  {
    value: '',
    label: 'selectBillingPeriod',
  },
  {
    value: 'monthly',
    label: 'monthly',
  },
  {
    value: 'thirty_days',
    label: 'thirty_days',
  },
  {
    value: 'quarterly',
    label: 'quarterly',
  },
  {
    value: 'half_yearly',
    label: 'half_yearly',
  },
  {
    value: 'yearly',
    label: 'yearly',
  },
  {
    value: 'custom',
    label: 'custom',
  },
];

export const customBillingOptions = [
  {
    value: '',
    label: 'selectBillingPeriodUnit',
  },
  {
    value: 'day',
    label: 'days',
  },
  {
    value: 'week',
    label: 'weeks',
  },
  {
    value: 'month',
    label: 'months',
  },
  {
    value: 'year',
    label: 'years',
  },
];

export const DATE_PICKER_MONTHS_LIST = [
  'january',
  'february',
  'march',
  'april',
  'may',
  'june',
  'july',
  'august',
  'september',
  'october',
  'november',
  'december',
];

export const DATE_PICKER_YEAR_LIMIT = 100;

export const PlanRenwalSettings = [
  {
    name: 'autoRenew',
    isAutoRenew: true,
    description: 'autoRenewHelpText',
  },
  {
    name: 'expireSubscription',
    isAutoRenew: false,
    description: 'expireSubscriptionHelpText',
  },
];
export const DEFAULT_PAGE_SIZE = 20;
export const DEFAULT_PAGE_INDEX = 1;
export const DEFAULT_ORDER_BY = 'createdAt';
export const DEFAULT_ORDER_DIRECTION = 'desc';

export const packageCreationSteps = [
  { id: 1, name: 'addTextAndImage' },
  { id: 2, name: 'addPlan' },
  { id: 3, name: 'settings' },
];

export const workflowCreationSteps = [
  { id: 1, name: 'workflowBasicInfo' },
  { id: 2, name: 'workflowActions' },
];

export const MINIMUM_PACKAGE_PRICE = 3; // In nok

export const SUPPORT_EMAIL = 'support@subrite.no';

export const MINIMUM_MEMBERS_SEARCH_TAKE = 5;

export const MAXIMUM_MEMBERS_SEARCH_TAKE = 1000;

export const MINIMUM_LENGTH_WORKFLOW_NAME = 5;

export const FILE_STORAGE_FOLDER = 'storage';

export const SUBSCRIPTION_STATUS_LIST = [
  {
    id: 'active',
    name: 'active',
  },
  {
    id: 'inactive',
    name: 'inactive',
  },
  {
    id: 'pending',
    name: 'pending',
  },
  {
    id: 'paused',
    name: 'paused',
  },
  {
    id: 'stopped',
    name: 'stopped',
  },
  {
    id: 'waiting_for_activation',
    name: 'waiting_for_activation',
  },
];

export const PAYMENT_PROIVDER_LIST = [
  {
    id: 'stripe',
    name: 'stripe',
  },
  {
    id: 'vipps',
    name: 'vipps',
  },
  {
    id: 'nets',
    name: 'nets',
  },
  {
    id: 'external',
    name: 'external',
  },
];

export const ALLOWED_MEMBER_LIST_COLUMNS_FOR_SORTING = ['email', 'createdAt'];
export const ALLOWED_MEMBER_LIST_ORDER_DIRECTION_FOR_SORTING = ['asc', 'desc'];

export const APPLICATION_TYPE_OPTIONS_FOR_SUBRITE_ID = ['web', 'native'];

export enum APPLICATION_TYPE_OPTIONS_FOR_SUBRITE_ID_ENUM {
  WEB = 'web',
  NATIVE = 'native',
}

export const PURPOSE_MARKETING_AND_NEWSLETTER = 'marketing_and_newsletter';
export const PURPOSE_CONSENT = 'consent';

export const ConsentPurposeOptions = [
  {
    value: PURPOSE_MARKETING_AND_NEWSLETTER,
    label: 'Marketing and newsletter',
  },
  {
    value: PURPOSE_CONSENT,
    label: 'Consent',
  },
];
export const FILE_PREVIEW_DISPLAY_LIMIT = 10;

export const IMPORT_HISTORY_TAG = 'importHistory';
